<template>    
    <div class="modal fade" id="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md modal-md-dhk modal-dialog-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <Breadcrumb :breadcrumb="breadcrumb"/>
                    <div class="modal-title w-100">
                        <h2 class="title--1">
                            {{title}}
                        </h2>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text">
                            Select a Group, enter a Name and Save. Salary fields are optional.
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="">
                    </button>
                </div>
                <div class="modal-body">
                    <form class="col-12 p-0" @submit.prevent="form_submit()">

                        <FormDynamic
                            :form_format="form_format"
                            :form_data="form_data"
                            :array_options="array_options"
                            :for_update="false"
                        />
                        <CentralButtons />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        CentralButtons,
    },

    data(){
        return{
            levels:         [],
            areas:          [],
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
        }
    },

    methods:{
        
    },

    mounted(){

    }
    
}
</script>